import React from 'react';

import Header from '../../Globals/Header/Header';

import './BasicLayout.scss';

const BasicLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="basic-layout">
      <Header />
      <div className="basic-layout-content">{children}</div>
    </div>
  );
};

export default BasicLayout;
